import { createContext } from 'react';

export type SessionContextType = {
  user: any;
  checkUserHasActiveSession?: () => boolean | undefined;
  ensureActiveSession?: (callback: any) => any;
};
export const SessionContext = createContext<SessionContextType | null>(null);
